// Vote totals for a post. Prefers the database-maintained counters and falls
// back to the legacy arrays for rows loaded before blog-votes.sql was run.
export function getVoteCounts(post) {
    const upvotes = Number(post?.upvote_count ?? post?.upvoted_by?.length ?? 0) || 0;
    const downvotes = Number(post?.downvote_count ?? post?.downvoted_by?.length ?? 0) || 0;
    return { upvotes, downvotes, score: upvotes - downvotes };
}
